import { CIcon } from '~/icons/types'

export const ciBoatFerry: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12.06 9.698a.514.514 0 0 0-.652.269.469.469 0 0 0-.038.19.404.404 0 0 0 .04.19.451.451 0 0 0 .27.27.5.5 0 0 0 .54-.1.454.454 0 0 0 .11-.17.407.407 0 0 0 .04-.19.47.47 0 0 0-.15-.35.458.458 0 0 0-.16-.11Zm2.83 0a.514.514 0 0 0-.652.269.47.47 0 0 0-.038.19.407.407 0 0 0 .04.19.454.454 0 0 0 .27.27c.06.03.124.043.19.04a.406.406 0 0 0 .19-.04.451.451 0 0 0 .27-.27.405.405 0 0 0 .04-.19.469.469 0 0 0-.15-.35.457.457 0 0 0-.16-.11Zm-6.04-.002a.457.457 0 0 0-.16.11.47.47 0 0 0-.15.35.406.406 0 0 0 .04.19.484.484 0 0 0 .46.31.431.431 0 0 0 .19-.04.452.452 0 0 0 .27-.27.406.406 0 0 0 .04-.19.469.469 0 0 0-.15-.35.5.5 0 0 0-.54-.11Zm-2.83 0a.457.457 0 0 0-.16.11.469.469 0 0 0-.15.35.406.406 0 0 0 .04.19.451.451 0 0 0 .27.27c.06.029.125.043.19.04a.431.431 0 0 0 .19-.04.452.452 0 0 0 .27-.27.406.406 0 0 0 .04-.19.469.469 0 0 0-.15-.35.5.5 0 0 0-.54-.11Z'
    },
    {
      d:
        'M23.239 12.491h-2.978L17.57 7.107a.5.5 0 0 0-.448-.277h-5.9l-.452-2.422A.5.5 0 0 0 10.279 4h-2.12a.5.5 0 0 0-.5.5v2.33H6.624L6.17 4.408A.5.5 0 0 0 5.679 4H3.57a.5.5 0 0 0-.5.5v2.33H.957a.5.5 0 0 0 0 1h.913v4.661H.501a.5.5 0 0 0-.5.5v5.661a.5.5 0 0 0 .5.5h1.463a.915.915 0 0 1 .915.915.5.5 0 0 0 .5.5h15.614a.499.499 0 0 0 .5-.501c0-1 .706-1.578 1.6-2.315 1.179-.969 2.645-2.175 2.645-4.761a.5.5 0 0 0-.499-.499ZM8.659 5h1.2l.341 1.83H8.659V5ZM4.066 5H5.27l.342 1.83H4.07L4.066 5ZM2.87 7.83h13.944l2.329 4.661H2.87V7.83Zm17.587 9.15a4.472 4.472 0 0 0-1.925 2.587H3.813a1.918 1.918 0 0 0-1.849-1.415h-.963v-4.661h21.7a4.931 4.931 0 0 1-2.242 3.489h-.002Z'
    },
    {
      d:
        'M4.794 15.32H3.379a.5.5 0 0 0 0 1h1.415a.5.5 0 0 0 0-1Zm4.245 0H7.624a.5.5 0 0 0 0 1h1.415a.5.5 0 0 0 0-1Zm4.246 0H11.87a.5.5 0 1 0 0 1h1.415a.5.5 0 0 0 0-1Zm4.246 0h-1.416a.5.5 0 1 0 0 1h1.416a.5.5 0 0 0 0-1Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'boat-ferry',
  type: 'thin'
}
